// extracted by mini-css-extract-plugin
export default {"hover":"CSSpan_hover__0tj50","underlineHover":"CSSpan_underlineHover__SRPvP","underlineAlways":"CSSpan_underlineAlways__6EZZD","disabled":"CSSpan_disabled__M2kal"};